import { useQuery } from "react-query";
import { MRT_PaginationState } from "mantine-react-table";
import getPaymentsListing, {
  PaymentsListingResponse,
} from "../services/getPaymentsListing";
function useGetPaymentsListing(
  token: string,
  externalAccount: string,
  pagination: MRT_PaginationState,
  refreshKey: number,
  startDate?: string,
  endDate?: string
) {
  return useQuery<PaymentsListingResponse>({
    queryKey: [
      "getPaymentsListing",
      externalAccount,
      pagination,
      refreshKey,
      startDate,
      endDate,
    ], //refetch whenever the URL changes (pagination)
    queryFn: () =>
      getPaymentsListing({
        token,
        externalAccount,
        pagination,
        startDate,
        endDate,
      }),
    retry: false,
    keepPreviousData: true, //useful for paginated queries by keeping data from previous pages on screen while fetching the next page
    staleTime: 30_000, //don't refetch previously viewed pages until cache is more than 30 seconds old
  });
}

export default useGetPaymentsListing;
